// extracted by mini-css-extract-plugin
export default {"open-source":"open-source--Dosiv"};